(function () {
  function waitForjQuery(trigger, delayInterval, delayTimeout) {
    var intervalForjQuery = setInterval(function() {
      if (typeof window.jQuery != 'undefined') {
        clearInterval(intervalForjQuery);
        trigger();
      }
    }, delayInterval);
    var timeoutForjQuery = setTimeout(function() {
      clearInterval(intervalForjQuery);
    }, delayTimeout);
  }

  function updateCart(responseText) {
    var $ = window.jQuery;
    // hide loader icon
    $('#MainContent .cart-item .loading-overlay').addClass('hidden');
    // hide cart lines
    $('#MainContent .cart-item').addClass('hidden');

    var items = responseText.items;
    $.each(items, function(index, item) {
      var url = item.url;
      var finalLinePrice = (item.final_line_price / 100);
      
      $('#MainContent .cart-item').each(function(i, cartItemName) {
        var href = $(this).find('.cart-item__name').attr('href');
        if (href.indexOf(url) > -1) {
          $(this).find('.cart-item__price-wrapper .price').html('$' + finalLinePrice);
          // show cart line
          $(this).removeClass('hidden');
          // update index
          $(this).find('.quantity__input[name="updates[]"]').attr('data-index', index+1);
          $(this).find('cart-remove-button').attr('data-index', index+1);
        }
      });
    });
  }

  function init() {
    var $ = window.jQuery;

    $(document).ajaxComplete(function(event, xhr, settings) {
      if (settings.url.indexOf('/cart.js?gh=true') > -1) {
        var responseText = JSON.parse(xhr.responseText);

        if (responseText.item_count > 0) {
          updateCart(responseText);
        }
      }
    });

    function observer_callback(list, observer) {
      for (const entry of list.getEntries()) {
        if (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest") {
          if (entry.name.indexOf('/cart/update.js') > -1 || entry.name.indexOf('/cart/change') > -1) {
            $.get('/cart.js?gh=true', function(data) {
              // 
            });
          }
        }
      }
    }

    let observer = new PerformanceObserver(observer_callback);
    observer.observe({
      entryTypes: ["resource"]
    });
  }

  waitForjQuery(init, 50, 10000);
})();
